import React from 'react'

const Asterisk: React.FC = () => {
  return <span style={{ color: 'rgb(212, 53, 28)' }}>*</span>
}

export default Asterisk
